module.exports = __webpack_public_path__ + "static/media/trashOrange.0d989e36.svg";